import { medpayFunctions } from "../../../../lib/medpay";
import { caseActions } from "../../../../store/case";
import DefaultUpdater from "../../../common/DefaultUpdater";
import { useDispatch, useSelector } from "react-redux";
import CardGrey from "../../../common/CardGrey";

import { hasPipOrMP } from "../../../../lib/verifications";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import PannelFooter from "../../../fragments/PannelFooter";
import Button from "../../../common/Button";
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { frontendOptions } from "../../../../lib/systemData";
import { formatPatientName, isPatientInsuredName } from "../../../../lib/patientName";
import classes from "./InsuranceOwner.module.css";
import { notificationActions } from "../../../../store/notifications";
import CheckboxCell from "../../../common/interactive/CheckboxCell";


export default function InsuranceOwnerV2({data, branch}) {
    let itemData = data
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)
    const userToken = useSelector(state => state.user.token)

    const [showModal, setShowModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showInvolvedCarInsuranceModal, setShowInvolvedCarInsuranceModal] = useState(false)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [showDriverExcludedModal, setShowDriverExcludedModal] = useState(false)

    async function insOwnerExtra(data) {
        let extraIdentifier = branch == 'medpay' ? {type: 'case_mp_pip_um', field: 'is_primary_insurance', type_id: itemData.id, folder: 'mp_pip_um'} : {type: 'case_mp_pip_um', field: 'is_um_primary_insurance', type_id: itemData.id, folder: 'mp_pip_um'}
        let extraIdentifier2 = {type: 'case_mp_pip_um', field: 'driver_excluded', type_id: itemData.id, folder: 'mp_pip_um'}
        let reqBody = {
            type: extraIdentifier.type,
            type_id: extraIdentifier.type_id,
            fields: {
                [extraIdentifier.field] : 1,
                [extraIdentifier2.field] : null,
            }
        }
        let dispatchBody = {
            folder: data.identifier.folder,
            item: {
                itemId: itemData.id,
                field: extraIdentifier.field,
                value: 1,
            },
            groupRelation: {
                field: extraIdentifier.field,
                value: 0,
            }
        }
        
        dispatch(caseActions.modifyActiveCase({
            folder: data.identifier.folder,
            item: {
                itemId: itemData.id,
                field: extraIdentifier2.field,
                value: null,
            },
        }))
        if (branch == 'medpay') {           
            if ((data.data.value == 1) && (hasPipOrMP(itemData, activeCase?.case?.state))) { // if driver and there is PIP or MP
                dispatch(caseActions.modifyActiveCase(dispatchBody))
                await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
            }
        }
    }

    async function selfExcludesExcludedDriver(data) {
        if (data.data.value == 1 || data.data.value == true) {
            //exclude driver should be set as false
            let extraIdentifier = {type: 'case_mp_pip_um', field: 'driver_excluded', type_id: itemData.id, folder: 'mp_pip_um'}
            let reqBody = {
                type: extraIdentifier.type,
                type_id: extraIdentifier.type_id,
                fields: {
                    [extraIdentifier.field] : 0,
                }
            }
            dispatch(caseActions.modifyActiveCase({
                folder: extraIdentifier.folder,
                item: {
                    itemId: itemData.id,
                    field: extraIdentifier.field,
                    value: 0,
                }
            }))
    
            await caseQuickUpdate(userToken, activeCase.case.id, reqBody)


            //the name of the patient should be copied into the Name of Insured
            let extraIdentifiersecond = {type: 'case_mp_pip_um', field: 'insured_name', type_id: itemData.id, folder: 'mp_pip_um'}
            const patientDisplayName = formatPatientName(activeCase.patient)

            if (!itemData.insured_name) { // there is no insured_name
                let reqBodysecond = {
                    type: extraIdentifiersecond.type,
                    type_id: extraIdentifiersecond.type_id,
                    fields: {
                        [extraIdentifiersecond.field] : patientDisplayName,
                    }
                }
                dispatch(caseActions.modifyActiveCase({
                    folder: extraIdentifiersecond.folder,
                    item: {
                        itemId: itemData.id,
                        field: extraIdentifiersecond.field,
                        value: patientDisplayName,
                    }
                }))
        
                await caseQuickUpdate(userToken, activeCase.case.id, reqBodysecond)
            } else {
                if (itemData.insured_name && !isPatientInsuredName(itemData.insured_name, activeCase.patient)) {
                    setShowModal(true)
                }
            }
        }
        
    }

    async function overWriteData() {
        setIsLoading(true)

        try {
            let extraIdentifiersecond = {type: 'case_mp_pip_um', field: 'insured_name', type_id: itemData.id, folder: 'mp_pip_um'}
            const patientDisplayName = formatPatientName(activeCase.patient)
            let reqBodysecond = {
                type: extraIdentifiersecond.type,
                type_id: extraIdentifiersecond.type_id,
                fields: {
                    [extraIdentifiersecond.field] : patientDisplayName,
                }
            }
            dispatch(caseActions.modifyActiveCase({
                folder: extraIdentifiersecond.folder,
                item: {
                    itemId: itemData.id,
                    field: extraIdentifiersecond.field,
                    value: patientDisplayName,
                }
            }))

            await caseQuickUpdate(userToken, activeCase.case.id, reqBodysecond)
            setShowModal(false)
        } finally {
            setIsLoading(false)
        }
    }

    function closeModalHandler() {
        setShowModal(false)
    }  

    let driverExcludedExtraIdentifier = {type: 'case_mp_pip_um', field: 'driver_excluded', type_id: itemData.id, folder: 'mp_pip_um'}
    function driverExcludedAction(data) {
        if (data.data.value == 1 || data.data.value == true) {
            setShowDriverExcludedModal(true)
        } else {
            updateFunction(0, driverExcludedExtraIdentifier)
        }
    }

    let involvedCarInsuranceExtraIdentifier = {type: 'case_mp_pip_um', field: 'ins_of_involved_car', type_id: itemData.id, folder: 'mp_pip_um'}
    function involvedCarInsuranceAction(data) {
        // to check on stg first!!!!!!!!!!!!!!!!!!
        if (data.ins_case_owner_id && data.ins_case_owner_id != activeCase.case.id && (data.data.value == 0 || data.data.value == false)) {
            setShowInvolvedCarInsuranceModal(true)
        } else {
            updateFunction(data.data.value, involvedCarInsuranceExtraIdentifier)
        } 
    }

    function closeInvolvedCarInsuranceModalHandler() {
        setShowInvolvedCarInsuranceModal(false)
    }

    function closeDriverExcludedModalHandler() {
        setShowDriverExcludedModal(false)
    }


    // async function updateInvolvedCarInsurance(value) {
    //     setIsRemovingInvolvedCarInsuranceLoading(true)
    //     setShowInvolvedCarInsuranceModal(false)
    //     let extraIdentifier = {type: 'case_mp_pip_um', field: 'ins_of_involved_car', type_id: itemData.id, folder: 'mp_pip_um'}
    //     let reqBody = {
    //         type: extraIdentifier.type,
    //         type_id: extraIdentifier.type_id,
    //         fields: {
    //             [extraIdentifier.field] : value,
    //         }
    //     }
    //     dispatch(caseActions.modifyActiveCase({
    //         folder: extraIdentifier.folder,
    //         item: {
    //             itemId: itemData.id,
    //             field: extraIdentifier.field,
    //             value: value,
    //         }
    //     }))
    //     let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
    //     if (update && update.errorMessage) {
    //         dispatch(notificationActions.setError(update))
    //     } else {
    //         if (value == 0) {
    //             let dispatchBody = {
    //                 folder: 'mp_pip_um',
    //                 itemId: itemData.id
    //             }
    //             dispatch(caseActions.removeFromArray(dispatchBody))
    //         }
    //     }
    //     setIsRemovingInvolvedCarInsuranceLoading(false)
    // }

    async function updateFunction(value, extraIdentifier) {
        setUpdateLoading(true)

        try {
            // let extraIdentifier = {type: 'case_mp_pip_um', field: 'ins_of_involved_car', type_id: itemData.id, folder: 'mp_pip_um'}
            let reqBody = {
                type: extraIdentifier.type,
                type_id: extraIdentifier.type_id,
                fields: {
                    [extraIdentifier.field] : value,
                }
            }
            let dispatchBody = {
                folder: extraIdentifier.folder,
                item: {
                    itemId: itemData.id,
                    field: extraIdentifier.field,
                    value: value,
                }
            }
            dispatch(caseActions.modifyActiveCase(dispatchBody))
            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)
            if (update?.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {
                if (extraIdentifier.field == 'ins_of_involved_car') {
                    setShowInvolvedCarInsuranceModal(false)
                    if (value == 0) {
                        if (!data.self) {
                            let dispatchBody = {
                                folder: 'mp_pip_um',
                                itemId: itemData.id
                            }
                            dispatch(caseActions.removeFromArray(dispatchBody))
                        }
                        
                    }
                    
                }

                if (extraIdentifier.field == 'driver_excluded') {
                    setShowDriverExcludedModal(false)
                }
            }
        } finally {
            setUpdateLoading(false)
        }
    }

    const [isInvlovedCarSelected, setIsInvlovedCarSelected] = useState(false)

    useEffect(() => {
        let isInvlovedCarSelected = activeCase.mp_pip_um.some(item => item.ins_of_involved_car)
        let insurabceIdWithInvolvedCar = activeCase.mp_pip_um.find(item => item.ins_of_involved_car)?.id

        if (isInvlovedCarSelected) {
            
            if (insurabceIdWithInvolvedCar !== itemData.id) {
                setIsInvlovedCarSelected(true)
            } else {
                setIsInvlovedCarSelected(false)
            }
        } else {
            setIsInvlovedCarSelected(false)
        }
    }, [activeCase.mp_pip_um])


    const blockDriverAlreadySelected = medpayFunctions.isDriverAlreadySelected(activeCase, itemData) ? {value: 1, message: 'Driver already selected'} : null

    let disableSelfCheckbox =  data.ins_case_owner_id ? data.ins_case_owner_id != activeCase.case.id : false

    return <>
        <CardGrey>
            <DefaultUpdater type={'checkbox'} value={data.self} name={'self'} label={'Self'} identifier={{type: 'case_mp_pip_um', field: 'self', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true, isDisabled: disableSelfCheckbox}} extraAction={selfExcludesExcludedDriver}/>
        </CardGrey>



        {!isInvlovedCarSelected && <>
            <CardGrey>
                {/* <DefaultUpdater type={'checkbox'} value={data.ins_of_involved_car} name={'ins_of_involved_car'} label={'Ins. of involved car'} identifier={{type: 'case_mp_pip_um', field: 'ins_of_involved_car', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true}} extraAction={involvedCarInsuranceAction}/> */}
                <CheckboxCell 
                    checked={data.ins_of_involved_car} 
                    name={'ins_of_involved_car'} 
                    label={'Ins. of involved car'} 
                    identifier={{type: 'case_mp_pip_um', field: 'ins_of_involved_car', type_id: data.id, folder: 'mp_pip_um'}} 
                    direction={'reverse'} 
                    trueFlagDanger={true} 
                    action={involvedCarInsuranceAction}
                    conditionalCheck={true}                    
                />
            </CardGrey>
            {data.ins_of_involved_car ?<>
                <CardGrey >
                {/* extraAction={insOwnerExtra} */}
                    <DefaultUpdater type={'radio'} value={data.ins_owner} options={frontendOptions()?.medpayins_owner} name={'ins_owner'} identifier={{type: 'case_mp_pip_um', field: 'ins_owner', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{normalSize: true}}  />
                </CardGrey>  
                {/* {!data.self && <> */}
                    {data.ins_owner == 1 && <CardGrey>
                        {/* <DefaultUpdater type={'checkbox'} value={data.driver_excluded} name={'driver_excluded'} label={'Excluded Driver'} identifier={{type: 'case_mp_pip_um', field: 'driver_excluded', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true}}/> */}
                        <CheckboxCell 
                        checked={data.driver_excluded} 
                        name={'driver_excluded'} 
                        label={'Excluded Driver'} 
                        identifier={{type: 'case_mp_pip_um', field: 'driver_excluded', type_id: data.id, folder: 'mp_pip_um'}} 
                        direction={'reverse'} 
                        trueFlagDanger={true} 
                        action={driverExcludedAction}
                        conditionalCheck={true}
                        />
                    </CardGrey>}
                {/* </>}  */}
            </> : null}
        </>}




        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Warning'}>       
                                      
                            <PannelBody>     
                                <p>Name of insured, does not match the name of the Patient. Would you like to update it?</p> 
                            </PannelBody>                            
                            <PannelFooter>
                                <div className={`flex-container`}>
                                    <Button click={overWriteData} btnStyle={'btn_danger'} isLoading={isLoading}>Yes</Button>
                                    <Button click={closeModalHandler}>No</Button>
                                </div>
                            </PannelFooter>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {showInvolvedCarInsuranceModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeInvolvedCarInsuranceModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeInvolvedCarInsuranceModalHandler} modalTitle={'Warning'}>       
                                      
                            <PannelBody>     
                                <p>If you uncheck the “Insurance of the car” option, this insurance will be removed from all related patients except Self. Do you want to proceed?</p> 
                            </PannelBody>                            
                            <PannelFooter>
                                <div className={`flex-container`}>
                                    <Button click={() => updateFunction(0, involvedCarInsuranceExtraIdentifier)} btnStyle={'btn_danger'} isLoading={updateLoading}>Yes</Button>
                                    <Button click={closeInvolvedCarInsuranceModalHandler}>No</Button>
                                </div>
                            </PannelFooter>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {showDriverExcludedModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeDriverExcludedModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeDriverExcludedModalHandler} modalTitle={'Warning'}>       
                        <PannelBody>     
                            <p>If you check the “Driver Excluded” option, This insurance will be denied for all related patients as well. Do you want to proceed?</p> 
                        </PannelBody>                            
                        <PannelFooter>
                            <div className={`flex-container`}>
                                <Button click={() => updateFunction(1, driverExcludedExtraIdentifier)} btnStyle={'btn_danger'} isLoading={updateLoading}>Yes</Button>
                                <Button click={closeDriverExcludedModalHandler}>No</Button>
                            </div>
                        </PannelFooter>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}